import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SubscriptionPageContent from '../components/SubscriptionPageContent';
import '../styles/subscription.css';
import '../styles/app.css';

/**
 * Subscription Page Component
 * Displays pricing cards for both authenticated and unauthenticated users
 * Unauthenticated users see disabled buttons with "Login to Subscribe"
 * Accessible at /subscription route
 */
const Subscription = () => {
  const navigate = useNavigate();
  const { token } = useAuth();

  const isAuthenticated = !!token;

  // For authenticated users, redirect to main app (ChatWindow will handle subscription display)
  if (isAuthenticated) {
    // Already at /subscription, no need to redirect
    // ChatApp will render ChatWindow with isSubscriptionRoute=true
    return null;
  }

  // Unauthenticated view - show pricing cards with disabled buttons
  const handleLoginRedirect = () => {
    navigate('/login?redirect=subscription');
  };

  return (
    <div className="subscription-page-standalone">
      <div className="subscription-page-header">
        <button
          onClick={() => navigate('/')}
          className="back-to-home-btn"
        >
          ← Back to Home
        </button>
      </div>
      <SubscriptionPageContent
        onOpenSubscriptionModal={handleLoginRedirect}
        userProfile={null}
      />
    </div>
  );
};

export default Subscription;
